import type { R3FieldSetClass } from "../base/R3FieldSet.classes";
import { R3InputNumberClass } from "../base/R3InputBase.classes";
import { R3LabelClass } from "../../components/R3/R3Label/classes/R3Label.classes";

export class UMAPaleteConferidoTabClass {
  visible = ref<boolean>(true);

  // Fieldet descricao mercadoria
  fieldsetDescricaoDaMercadoria = autoRef<R3FieldSetClass>();
  labelCodigoMercadoria = autoRef<R3LabelClass>(new R3LabelClass());
  labelDescricaoMercadoria = autoRef<R3LabelClass>(new R3LabelClass());
  labelQuantidadeMercadoria = autoRef<R3LabelClass>(new R3LabelClass());
  labelValidadeMercadoria = autoRef<R3LabelClass>(new R3LabelClass());

  // ---------------

  // Fieldset atencao
  fieldsetAtencao = autoRef<R3FieldSetClass>(null);
  labelUMA = autoRef<R3LabelClass>(new R3LabelClass());

  // ----------------
  // Fieldset UMA
  fieldsetUMA = autoRef<R3FieldSetClass>(null);
  inputUMA = autoRef<R3InputNumberClass>(new R3InputNumberClass());

  registrouUMAClicked = ref<boolean>(false);
}
